/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SearchChatsPayload,
  SearchChatsPayload$Outbound,
  SearchChatsPayload$outboundSchema,
} from "../components/searchchatspayload.js";

export type SearchChatsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SearchChatsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SearchChatsSecurity = {
  option1?: SearchChatsSecurityOption1 | undefined;
  option2?: SearchChatsSecurityOption2 | undefined;
};

export type SearchChatsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  searchChatsPayload: SearchChatsPayload;
};

/** @internal */
export type SearchChatsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SearchChatsSecurityOption1$outboundSchema: z.ZodMiniType<
  SearchChatsSecurityOption1$Outbound,
  SearchChatsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function searchChatsSecurityOption1ToJSON(
  searchChatsSecurityOption1: SearchChatsSecurityOption1,
): string {
  return JSON.stringify(
    SearchChatsSecurityOption1$outboundSchema.parse(searchChatsSecurityOption1),
  );
}

/** @internal */
export type SearchChatsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SearchChatsSecurityOption2$outboundSchema: z.ZodMiniType<
  SearchChatsSecurityOption2$Outbound,
  SearchChatsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function searchChatsSecurityOption2ToJSON(
  searchChatsSecurityOption2: SearchChatsSecurityOption2,
): string {
  return JSON.stringify(
    SearchChatsSecurityOption2$outboundSchema.parse(searchChatsSecurityOption2),
  );
}

/** @internal */
export type SearchChatsSecurity$Outbound = {
  Option1?: SearchChatsSecurityOption1$Outbound | undefined;
  Option2?: SearchChatsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SearchChatsSecurity$outboundSchema: z.ZodMiniType<
  SearchChatsSecurity$Outbound,
  SearchChatsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SearchChatsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SearchChatsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function searchChatsSecurityToJSON(
  searchChatsSecurity: SearchChatsSecurity,
): string {
  return JSON.stringify(
    SearchChatsSecurity$outboundSchema.parse(searchChatsSecurity),
  );
}

/** @internal */
export type SearchChatsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SearchChatsPayload: SearchChatsPayload$Outbound;
};

/** @internal */
export const SearchChatsRequest$outboundSchema: z.ZodMiniType<
  SearchChatsRequest$Outbound,
  SearchChatsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    searchChatsPayload: SearchChatsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      searchChatsPayload: "SearchChatsPayload",
    });
  }),
);

export function searchChatsRequestToJSON(
  searchChatsRequest: SearchChatsRequest,
): string {
  return JSON.stringify(
    SearchChatsRequest$outboundSchema.parse(searchChatsRequest),
  );
}
